import { MultipleLookupBaseControl } from "./multiple-lookup-base-control";
import { LookupValue } from "../../../../../models/lookups/lookup.models";
import { type MultipleLookupValues, type MultipleLookupExclusiveAnswers } from "../multiple-lookups-control";
import { bindable, autoinject } from "aurelia-framework";

@autoinject
export class MultipleLookupCheckBoxes extends MultipleLookupBaseControl {
	
	@bindable
	protected itemSource: LookupValue[];

	@bindable
	protected values: MultipleLookupValues;

	@bindable
	protected exclusiveAnswers: MultipleLookupExclusiveAnswers;

	@bindable
	protected readonly: boolean = false;
	
	public constructor (protected element: Element) {
		super(element);
	}

	public onCheckBoxValueChanged(id: number): void {
		if (this.exclusiveAnswers[id]) {
			if (this.values[id]) {
				for (const key in this.values) {
					const currentId = Number(key);
	
					if (currentId == id) {
						continue;
					}
	
					this.delete(currentId);
				}
	
				this.selectedExclusiveId = id;
			} else {
				this.delete(id);
				this.selectedExclusiveId = null;
			}
		}

		this.dispatchValuesChangedEvent();
	}
}
